/**
 * !!!DO NOT EDIT THIS FILE!!!
 * If you need to regenerate it, please run `yarn generate:config:production`
 */
type Config = {
    LOG_APPLICATION_NAME: string;
    LOG_TAGS: string;
    LOG_SERVICE_KEY: string;
    LOG_DEPLOYMENT_KIND: string;
    LOG_SEPARATOR: string;
    LOG_ENABLED: string;
    LOG_LOGGLY_ENABLED: string;
    LOG_LOGGLY_MINLEVEL: string;
    LOG_LOGGLY_API_KEY: string;
    LOG_LOGGLY_CONSECUTIVE_OCCURRENCES: string;
    LOG_LOGGLY_MAX_BUNDLE_SIZE: string;
    LOG_CONSOLE_ENABLED: string;
    LOG_CONSOLE_MINLEVEL: string;
    MARKETPLACE_API_URL: string;
    INGESTION_API_URL: string;
    UPLOAD_API_URL: string;
    MAESTRO_THEME: string;
    SEGMENT_WRITE_KEY: string;
    AUTH0_DOMAIN: string;
    AUTH0_CLIENT_ID: string;
};

declare global {
    interface Window {
        LANDR_CONFIG: Config;
    }
}

if (process.env.NODE_ENV === 'test') {
    window.LANDR_CONFIG = JSON.parse(process.env.REACT_APP_CONFIG as string);
}

export const CONFIG: Config = window.LANDR_CONFIG;
